import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { uk, enUS } from 'date-fns/locale';

const dateFnsLocales: Record<string, Locale> = {
  uk,
  en: enUS,
};

if (localStorage.getItem('i18nextLng') === null) {
  localStorage.setItem('i18nextLng', 'uk');
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'uk',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: [
        'localStorage',
        'cookie',
        'htmlTag',
        'navigator',
        'path',
        'subdomain',
      ],
      caches: ['localStorage'],
    },
  });

export { dateFnsLocales };
export default i18n;
